
export class SortDTO {
    sorted: boolean;
    empty: boolean;
    unsorted: boolean;
}

export class PageableDTO {
    pageNumber: number;
    pageSize: number;
    sort: SortDTO;
    offset: number;
    paged: boolean;
    unpaged: boolean;
}

export class PageDTO {
    pageable: PageableDTO;
    last: boolean;
    totalPages: number;
    totalElements: number;
    first: boolean;
    size: number;
    number: number;
    sort: SortDTO;
    numberOfElements: number;
    empty: boolean;
}

export function getEmptyPageDto():PageDTO {
    return {
        pageable: {
            pageNumber: 0,
            pageSize: 1,
            sort: {
                sorted: false,
                empty: true,
                unsorted: false,
            },
            offset: 0,
            paged: true,
            unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 0,
        first: true,
        size: 1,
        number: 0,
        sort: {
            sorted: false,
            empty: true,
            unsorted: false,
        },
        numberOfElements: 0,
        empty: true
    };
}
